import { __awaiter } from "tslib";
import { fetchCapabilities } from '@office-start/capabilities-service';
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { getHarmonyAppDefinitions } from '@office-start/mos-app-utilities';
import { format } from '@office-start/string-formatter-utility';
import { logError } from '@office-start/telemetry-service';
import { applyOfficeIdentity, httpGet } from '@office-start/xhr-service';
import { appLookupUrlFormat } from '../constants/api';
/**
 * Download the latest M365 apps definition from MOS3`
 * @param m365AppsDefinitionLookupServiceProps - {@link M365AppDefinitionLookupServiceProps}
 * @returns Promise containing a list of {@link HarmonyAppDefinition}
 */
export const lookupM365AppDefinition = ({ officeComponentContext, appId, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const capabilities = yield fetchCapabilities();
    if (!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.m365AppsEnabled)) {
        return [];
    }
    const url = format(appLookupUrlFormat, officeComponentContext.officeHomeApiRoot, appId ? appId : '');
    const requestConfig = {
        method: "GET" /* HttpRequestMethod.Get */,
        responseType: "json" /* HttpResponseContentType.Json */,
        url,
    };
    const identityResult = getOfficeIdentity();
    const identity = identityResult ? identityResult : yield fetchIdentity();
    yield applyOfficeIdentity(requestConfig, officeComponentContext.inMockMode, officeComponentContext.workload, () => Promise.resolve(identity));
    let response;
    try {
        response = yield httpGet(KnownInstrumentationEvents.M365AppsDefinitionLookupRequest, "M365_Apps_Definition_Not_Found_In_Config_Retrying_Lookup" /* KnownRequestInstrumentationEvents.M365AppsDefinitionLookupRequest */, requestConfig.url, requestConfig, officeComponentContext.jwtAuthEnabled, officeComponentContext.getAccessToken, officeComponentContext.officeHomeApiRoot, officeComponentContext.correlationId, 'OfficeHome', {}, "network-only" /* FetchStrategy.NetworkOnly */);
    }
    catch (_b) {
        // Error handling below, httpGet logs errors
    }
    if (!response || !response.ok || !response.data) {
        const debugInfo = !!response
            ? `Response is truthy,
            is OK?: ${response === null || response === void 0 ? void 0 : response.ok},
            has data?: ${Boolean(response === null || response === void 0 ? void 0 : response.data)},
            response code: ${response === null || response === void 0 ? void 0 : response.status}`
            : 'Response is falsy';
        logError({
            eventName: KnownInstrumentationEvents.M365AppsDefinitionLookupError,
            errorType: 'App_Initialization_Error',
            message: "Failed to retrieve user's apps.",
            debugInfo,
        });
        return [];
    }
    return getHarmonyAppDefinitions((_a = response.data.getAcquisitionsResponse) === null || _a === void 0 ? void 0 : _a.acquisitions);
});
//# sourceMappingURL=lookupM365AppDefinition.js.map